/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, July 7th 2022, 5:00:04 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useToggleState } from "ui-widgets";
import { UseProcessStageAPIFormSpec } from "service-builder/services";
import { PopUpStageForm } from "./StageForm";

interface StageFormButtonWrapperProps
  extends Pick<UseProcessStageAPIFormSpec, "processStageFetchId" | "onSuccessfulAPISave"> {
  children: any;
}

export const StageFormButtonWrapper = ({
  children,
  processStageFetchId,
  onSuccessfulAPISave,
}: StageFormButtonWrapperProps) => {
  const { handleClose, handleOpen, open } = useToggleState();
  return (
    <>
      {React.Children.map(children, (child) => React.cloneElement(child, { onClick: handleOpen }))}{" "}
      <PopUpStageForm
        open={open}
        handleClose={handleClose}
        processStageFetchId={processStageFetchId}
        updateProcessStageFromAPICallback={null}
        processStageDefaultValues={null}
        onSuccessfulAPISave={onSuccessfulAPISave}
      />
    </>
  );
};
